import { HStack, IconButton, Text, useDisclosure } from "@chakra-ui/react";
import useTranslate from "@raiden/library/hooks/useTranslate";
import { memo } from "react";
import { useIntl } from "react-intl";
import { Href } from "../../../../../../components/Href";
import { Icon } from "../../../../../../components/Icon";
import { getMenuItemAdapterValues } from "../../../../../../helpers/menus/getMenuItemAdapterValues";
import { MenuPanel } from "./MenuPanel";

export const MenuItem = memo(
  /**
   * @typedef {Object} Props
   * @property {import("@raiden/library/types/Configuration").ConfigurationMenuItem} menuItem
   * @property {() => void} onClickSearch
   * @property {() => void} onClickMenu
   */
  /**
   * @param {Props} props
   */
  function MenuItem({ menuItem, onClickSearch, onClickMenu }) {
    const intl = useIntl();

    const {
      isOpen: isOpenPanel,
      onOpen: onOpenPanel,
      onClose: onClosePanel,
    } = useDisclosure();

    const translate = useTranslate();
    const { title, href, target } = getMenuItemAdapterValues({
      menuItem,
      translate,
    });

    return (
      <>
        <HStack
          minH="61px"
          spacing="0"
          borderColor="gray.400"
          _notFirst={{ borderTopWidth: "1px" }}>
          <Href href={href} target={target} flexGrow={1}>
            <HStack
              as={menuItem.children.length > 0 ? "button" : "div"}
              onClick={onOpenPanel}
              flexGrow={1}
              alignSelf="stretch">
              <Text fontSize="1rem" fontWeight={400} lineHeight="1.375rem">
                {title}
              </Text>
            </HStack>
          </Href>

          {menuItem.children.length > 0 && (
            <IconButton
              onClick={onOpenPanel}
              variant="ghost"
              h="60px"
              aria-label={intl.formatMessage({ defaultMessage: "Ouvrir" })}>
              <Icon icon="ms_chevron_right" size="1.5rem" />
            </IconButton>
          )}
        </HStack>

        {menuItem.children.length > 0 && (
          <MenuPanel
            isOpen={isOpenPanel}
            onClose={onClosePanel}
            menuItem={menuItem}
            onClickSearch={onClickSearch}
            onClickMenu={onClickMenu}
          />
        )}
      </>
    );
  },
);
